/* Feuillé — theme behaviour.
   Everything is delegated from document so sections re-rendered by the
   theme editor keep working without re-binding. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var configEl = document.getElementById('ThemeStrings');
  var T = {};
  try { T = JSON.parse(configEl.textContent) } catch (e) { T = {} }
  var moneyFormat = (configEl && configEl.dataset.moneyFormat) || '${{amount}}';
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function announce(message) {
    var live = document.getElementById('CartLive');
    if (live) live.textContent = message;
  }

  /* The same message, for anyone looking at the drawer rather than listening
     to it. An empty string clears it. */
  function cartNote(message) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-note]'), function (el) {
      el.textContent = message || '';
      el.hidden = !message;
    });
  }

  /* --- money -------------------------------------------------------------
     Shopify hands the format down as a Liquid-ish template; mirror the
     placeholders it can use so drawer totals match server-rendered prices. */
  function formatMoney(cents) {
    var value = Number(cents);
    if (isNaN(value)) return '';

    function group(decimals, thousands, decimalMark) {
      var parts = (value / 100).toFixed(decimals).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimalMark + parts[1] : whole;
    }

    var placeholder = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var name = placeholder ? placeholder[1] : 'amount';
    var out;
    if (name === 'amount_no_decimals') out = group(0, ',', '.');
    else if (name === 'amount_with_comma_separator') out = group(2, '.', ',');
    else if (name === 'amount_no_decimals_with_comma_separator') out = group(0, '.', ',');
    else if (name === 'amount_with_apostrophe_separator') out = group(2, "'", '.');
    else out = group(2, ',', '.');

    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --- header shadow on scroll ------------------------------------------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        header.classList.toggle('is-stuck', window.scrollY > 8);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- scroll reveal ------------------------------------------------------ */
  /* threshold is 0 - any part on screen - on purpose. It was 0.08, which
     asks for 8% of the element in view at once, and a whole product grid
     is one element: 48 products on a phone make it ~10,000px tall, of
     which a screen can hold ~7%, so the grid never qualified and every
     card stayed invisible however far the shopper scrolled. Any fraction
     of a size-dependent threshold fails the same way for some grid length,
     so do not put one back. The stagger delay is capped for the same
     reason: at 90ms a card, card 40 would wait 3.6s to appear. */
  function initReveal() {
    document.documentElement.classList.add('reveal-ready');
    var targets = document.querySelectorAll('.reveal, .stagger, .hero');
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-in') });
      return;
    }
    Array.prototype.forEach.call(document.querySelectorAll('.stagger'), function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.setProperty('--i', Math.min(i, 8));
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    Array.prototype.forEach.call(targets, function (el) { io.observe(el) });
  }
  initReveal();
  document.addEventListener('shopify:section:load', initReveal);

  /* --- drawers ------------------------------------------------------------ */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var openDrawer = null;
  var returnFocus = null;

  function visibleFocusable(container) {
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
  }

  function setDrawer(el, open) {
    if (!el) return;
    el.classList.toggle('is-open', open);
    el.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      returnFocus = document.activeElement;
      openDrawer = el;
      var close = el.querySelector('button[data-drawer-close]');
      if (close) close.focus();
    } else {
      openDrawer = null;
      if (returnFocus) { returnFocus.focus(); returnFocus = null }
    }
  }

  function closeAllDrawers() {
    Array.prototype.forEach.call(document.querySelectorAll('.drawer.is-open'), function (el) {
      setDrawer(el, false);
    });
  }

  var cartDrawer = document.getElementById('CartDrawer');
  var favDrawer = document.getElementById('FavoritesDrawer');

  /* --- mobile navigation -------------------------------------------------- */
  var nav = document.getElementById('SiteNav');
  var menuToggle = document.querySelector('.menu-toggle');
  var menuReturn = null;

  function setMenu(open) {
    if (!nav || !menuToggle) return;
    nav.classList.toggle('is-open', open);
    menuToggle.setAttribute('aria-expanded', String(open));
    if (open) {
      menuReturn = document.activeElement;
      var first = visibleFocusable(nav)[0];
      if (first) first.focus();
    } else if (menuReturn) {
      menuReturn.focus();
      menuReturn = null;
    }
  }

  /* --- cart --------------------------------------------------------------- */
  function cartRow(item) {
    var image = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="" width="64" height="64" loading="lazy">'
      : '<span class="placeholder-svg" style="display:block;aspect-ratio:1"></span>';
    return '<div class="cart-row" data-key="' + escapeHtml(item.key) + '">' +
      '<a href="' + escapeHtml(item.url) + '" tabindex="-1" aria-hidden="true">' + image + '</a>' +
      '<div>' +
        '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
        (item.variant_title ? '<small> ' + escapeHtml(item.variant_title) + '</small>' : '') +
        '<div class="price">' +
          (item.original_line_price !== item.final_line_price
            ? '<span class="cart-was">' + formatMoney(item.original_line_price) + '</span>'
            : '') +
          formatMoney(item.final_line_price) +
        '</div>' +
        '<div class="qty">' +
          '<button type="button" data-line-change="-1" aria-label="' + escapeHtml(T.decrease) + '">&minus;</button>' +
          '<input type="number" min="0" value="' + item.quantity + '" data-line-qty aria-label="' + escapeHtml(T.quantity) + '">' +
          '<button type="button" data-line-change="1" aria-label="' + escapeHtml(T.increase) + '">+</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* --- mixed-branch cart note ----------------------------------------------
     Real stock is split per branch, but Shopify's delivery-method choice
     (Ship vs Pickup) happens on checkout's own hosted page, which this
     theme cannot reach into or gate directly. Pickup only ever collects
     from one location, so the closest thing to actually stopping a
     short-handed pickup order is asking the intent here, on the last page
     still in theme control, and disabling that page's own Checkout control
     until either the answer or the bag changes. Ship is left alone -
     Shopify ships each branch's stock as its own parcel to one address. */
  /* Trimmed: products were entered with "Official Store " (trailing space)
     beside "Official Store", and compared as-is two lines from the same
     branch read as two branches - a false mixed-branch warning that also
     disabled Checkout on the cart page. Lines already in shoppers' carts
     carry the untrimmed value, so it is cleaned here, not only at source. */
  function lineBranch(item) {
    var b = item.properties && item.properties._branch;
    return b ? String(b).trim() : "";
  }

  function cartBranches(cart) {
    var seen = [];
    cart.items.forEach(function (item) {
      var b = lineBranch(item);
      if (b && seen.indexOf(b) === -1) seen.push(b);
    });
    return seen;
  }

  function branchNoteHtml(cart, branches) {
    var rows = branches.map(function (b) {
      var names = cart.items
        .filter(function (item) { return lineBranch(item) === b })
        .map(function (item) { return item.product_title })
        .join(', ');
      return '<li><b>' + escapeHtml(b) + '</b>: ' + escapeHtml(names) + '</li>';
    }).join('');
    return '<div class="cart-branch-note" data-branch-note>' +
      '<p>' + escapeHtml(T.mixed_branch_note || '') + '</p>' +
      '<ul>' + rows + '</ul>' +
      '<p class="fulfillment-prompt">' + escapeHtml(T.fulfillment_prompt || '') + '</p>' +
      '<div class="cart-branch-choice">' +
        '<label class="check"><input type="radio" name="fulfillment_intent" value="ship" data-fulfillment-intent> ' + escapeHtml(T.fulfillment_ship || '') + '</label>' +
        '<label class="check"><input type="radio" name="fulfillment_intent" value="pickup" data-fulfillment-intent> ' + escapeHtml(T.fulfillment_pickup || '') + '</label>' +
      '</div>' +
      '<p class="cart-branch-status is-neutral" data-branch-status>' + escapeHtml(T.fulfillment_unanswered || '') + '</p>' +
    '</div>';
  }

  /* Shared by the radios' change handler and by every drawer re-render,
     which always starts unanswered again - a fresh question for a bag that
     may have just changed. Silence defaults to blocked, not to delivery:
     leaving both radios unset holds Checkout disabled the same as picking
     Pickup does, since Shopify's checkout - a page outside the theme
     entirely - cannot be trusted to sort a mixed bag out on its own. */
  function updateCheckoutGate(root) {
    var checkoutEl = root.querySelector('[data-checkout-button]');
    if (!checkoutEl) return;
    var note = root.querySelector('[data-branch-note]');
    var status = note && note.querySelector('[data-branch-status]');
    var picked = note && note.querySelector('[data-fulfillment-intent]:checked');
    var blocked = true;
    var statusClass = 'is-neutral';
    var statusText = T.fulfillment_unanswered || '';

    if (!note) {
      blocked = false;
    } else if (picked && picked.value === 'ship') {
      blocked = false;
      statusClass = 'is-ok';
      statusText = T.fulfillment_ship_ok || '';
    } else if (picked && picked.value === 'pickup') {
      statusClass = 'is-blocked';
      statusText = T.pickup_blocked || '';
    }

    if (status) { status.textContent = statusText; status.className = 'cart-branch-status ' + statusClass; }
    if ('disabled' in checkoutEl) checkoutEl.disabled = blocked;
    checkoutEl.classList.toggle('is-blocked', blocked);
    if (blocked) checkoutEl.setAttribute('aria-disabled', 'true');
    else checkoutEl.removeAttribute('aria-disabled');
  }

  function renderCart(cart) {
    paintCount('[data-cart-count]', cart.item_count);
    if (!cartDrawer) return;
    var items = cartDrawer.querySelector('[data-drawer-items]');
    var empty = cartDrawer.querySelector('[data-drawer-empty]');
    var actions = cartDrawer.querySelector('[data-drawer-actions]');
    var subtotal = cartDrawer.querySelector('[data-drawer-subtotal]');
    var discountRow = cartDrawer.querySelector('[data-drawer-discount]');
    var discountAmount = cartDrawer.querySelector('[data-drawer-discount-amount]');
    if (!items) return;
    items.innerHTML = cart.items.map(cartRow).join('');
    if (empty) empty.hidden = cart.item_count > 0;
    if (actions) actions.hidden = cart.item_count === 0;
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (discountRow) discountRow.hidden = !(cart.total_discount > 0);
    if (discountAmount) discountAmount.textContent = cart.total_discount > 0 ? '−' + formatMoney(cart.total_discount) : '';

    var noteHost = cartDrawer.querySelector('[data-drawer-branch-note]');
    if (noteHost) {
      var branches = cartBranches(cart);
      noteHost.innerHTML = branches.length > 1 ? branchNoteHtml(cart, branches) : '';
      updateCheckoutGate(cartDrawer);
    }
  }

  function paintCount(selector, count) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (el) {
      el.textContent = count;
      el.hidden = !count;
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      if (count && !reduceMotion.matches) el.classList.add('is-bumped');
    });
  }

  function fetchCart(open) {
    return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json() })
      .then(function (cart) {
        renderCart(cart);
        if (open) setDrawer(cartDrawer, true);
        return cart;
      });
  }

  function changeLine(key, quantity) {
    return fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        if (r.ok) return r.json();
        /* Shopify answers a refused change with 422 and a body of
           {status, message, description} - no items array. That went straight
           into renderCart, which threw on cart.items.map, so asking for more
           than the shop holds looked to the customer like the button doing
           nothing at all. Their message already says what happened - "Only 1
           item was added to your cart due to availability." - so it is the
           one shown. Same shape as addToCart further down this file. */
        return r.json().catch(function () { return {} }).then(function (err) {
          throw new Error(err.description || err.message || r.statusText);
        });
      })
      .then(function (cart) {
        renderCart(cart);
        cartNote('');
        announce(T.cart_updated || '');
        if (document.body.classList.contains('template-cart')) window.location.reload();
        return cart;
      })
      .catch(function (err) {
        /* Put the drawer back to what the cart actually holds - the stepper
           has already moved in the markup - and then say why it did not
           take. */
        cartNote(String(err.message || ''));
        announce(String(err.message || ''));
        return fetchCart(false);
      });
  }

  /* --- favourites ---------------------------------------------------------
     Shopify has no wishlist resource, so handles live in localStorage and the
     product data is fetched back from the store when the drawer opens. */
  var FAV_KEY = 'feuille:favorites';

  function readFavorites() {
    try { return JSON.parse(window.localStorage.getItem(FAV_KEY)) || [] } catch (e) { return [] }
  }

  function writeFavorites(list) {
    try { window.localStorage.setItem(FAV_KEY, JSON.stringify(list)) } catch (e) { /* private mode */ }
    paintCount('[data-favorites-count]', list.length);
    syncFavoriteButtons(list);
  }

  function syncFavoriteButtons(list) {
    var saved = list || readFavorites();
    Array.prototype.forEach.call(document.querySelectorAll('[data-fav]'), function (button) {
      var on = saved.indexOf(button.dataset.fav) !== -1;
      button.setAttribute('aria-pressed', String(on));
      var label = button.querySelector('[data-fav-label]');
      if (label) label.textContent = on ? T.fav_saved : T.fav_save;
    });
  }

  function renderFavorites() {
    if (!favDrawer) return Promise.resolve();
    var handles = readFavorites();
    var items = favDrawer.querySelector('[data-favorites-items]');
    var empty = favDrawer.querySelector('[data-favorites-empty]');
    var actions = favDrawer.querySelector('[data-favorites-actions]');
    if (empty) empty.hidden = handles.length > 0;
    if (actions) actions.hidden = handles.length === 0;
    if (!items) return Promise.resolve();
    items.innerHTML = '';
    if (!handles.length) return Promise.resolve();

    return Promise.all(handles.map(function (handle) {
      return fetch(rootUrl + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null })
        .catch(function () { return null });
    })).then(function (products) {
      var alive = [];
      items.innerHTML = products.filter(Boolean).map(function (p) {
        alive.push(p.handle);
        var image = p.featured_image
          ? '<img src="' + escapeHtml(p.featured_image) + '" alt="" width="64" height="64" loading="lazy">'
          : '<span class="placeholder-svg" style="display:block;aspect-ratio:1"></span>';
        return '<div class="cart-row">' +
          '<a href="' + escapeHtml(rootUrl + 'products/' + p.handle) + '" tabindex="-1" aria-hidden="true">' + image + '</a>' +
          '<div>' +
            '<a href="' + escapeHtml(rootUrl + 'products/' + p.handle) + '">' + escapeHtml(p.title) + '</a>' +
            '<div class="price">' + formatMoney(p.price) + '</div>' +
            '<button class="btn-ghost" type="button" data-fav="' + escapeHtml(p.handle) + '" aria-pressed="true">' +
              escapeHtml(T.fav_remove) +
            '</button>' +
          '</div>' +
        '</div>';
      }).join('');
      /* drop handles whose products no longer exist */
      if (alive.length !== handles.length) writeFavorites(alive);
    });
  }

  function toggleFavorite(handle) {
    var list = readFavorites();
    var at = list.indexOf(handle);
    if (at === -1) { list.push(handle); announce(T.fav_added || '') }
    else { list.splice(at, 1); announce(T.fav_removed || '') }
    writeFavorites(list);
    if (favDrawer && favDrawer.classList.contains('is-open')) renderFavorites();
  }

  paintCount('[data-favorites-count]', readFavorites().length);
  syncFavoriteButtons();
  document.addEventListener('shopify:section:load', function () { syncFavoriteButtons() });


  /* --- branch -------------------------------------------------------------
     A branch is a collection, so the products come from Shopify; only which
     branch the visitor picked is remembered here. */
  var BRANCH_KEY = "feuille:branch";
  var branchMount = document.querySelector("[data-branch-mount]");
  var branchDrawer = document.getElementById("BranchDrawer");

  /* Where the choice lives decides how long it lasts: sessionStorage asks
     again on the next visit, localStorage remembers across visits. */
  function branchStore() {
    var mode = branchMount ? branchMount.dataset.branchMemory : "session";
    try {
      return mode === "persist" ? window.localStorage : window.sessionStorage;
    } catch (e) { return null }
  }

  function readBranch() {
    var store = branchStore();
    if (!store) return null;
    var stored;
    try { stored = JSON.parse(store.getItem(BRANCH_KEY)) } catch (e) { return null }
    /* An empty handle used to mean "browse everything", which left the gate
       permanently open. Treat that as no choice at all. */
    if (!stored || !stored.handle) return null;
    return stored;
  }

  function writeBranch(branch) {
    var store = branchStore();
    if (store) { try { store.setItem(BRANCH_KEY, JSON.stringify(branch)) } catch (e) { /* private mode */ } }
    var persist = branchMount && branchMount.dataset.branchMemory === "persist";
    document.cookie = "branch=" + encodeURIComponent(branch.handle) +
      ";path=/;samesite=lax" + (persist ? ";max-age=31536000" : "");
    /* Clear the other store so switching the setting cannot leave a stale choice. */
    try {
      (persist ? window.sessionStorage : window.localStorage).removeItem(BRANCH_KEY);
    } catch (e) { /* private mode */ }
    paintBranch();
  }

  function paintBranch() {
    var branch = readBranch();
    Array.prototype.forEach.call(document.querySelectorAll("[data-branch-label]"), function (el) {
      el.textContent = branch ? branch.name : T.branch_select;
      var button = el.closest("[data-branch-open]");
      if (button) {
        button.classList.toggle("is-set", !!branch);
        /* The desktop branch button is icon-only with its label
           visually-hidden (see .branch-btn in theme.css.liquid) - title
           gives a mouse user the same hover discoverability a visible
           label would, without spending header width on it. */
        button.title = branch ? branch.name : T.branch_select;
      }
    });
  }

  paintBranch();
  document.addEventListener("shopify:section:load", paintBranch);

  /* branch_page is a plain merchant-typed path ("/pages/branches"), not a
     Liquid route object, so it carries no locale prefix of its own - unlike
     routes.root_url and friends, which Shopify prefixes automatically for
     whichever published locale isn't the unprefixed default. Redirecting to
     it as-is silently dropped a shopper from /en back to the unprefixed
     locale on every "Shop" click and every first-visit gate redirect
     ("พอกดไปหน้าอื่นแล้วจะเด้งกลับภาษาอังกฤษตลอด" - reported after French was
     made the storefront's default, which is what made the drop visible).
     Shopify.locale names whichever locale is actually active on the page
     already doing the redirecting; if that's the prefix this page's own URL
     is already wearing, the same prefix belongs on the redirect target too. */
  function localizedPath(path) {
    var locale = window.Shopify && window.Shopify.locale;
    if (!locale) return path;
    var prefix = "/" + locale;
    var here = window.location.pathname;
    var hasPrefix = here === prefix || here.indexOf(prefix + "/") === 0;
    return hasPrefix ? prefix + path : path;
  }

  /* The click gate only covers links. Landing straight on a product or
     collection URL - typed, bookmarked, back button, or an external link -
     has to be caught on load too, or the branch step is skippable. */
  function gateOnLoad() {
    if (!branchMount || branchMount.dataset.gate !== "on") return;
    var page = branchMount.dataset.branchPage;
    if (!page) return;
    var here = window.location.pathname;
    if (here.indexOf(page) !== -1) return;
    var onProducts = here.indexOf("/collections") !== -1 || here.indexOf("/products") !== -1;
    if (!onProducts) return;

    /* Arriving on a branch-filtered URL is itself a choice; record it. */
    var params = new URLSearchParams(window.location.search);
    var filterKey = branchMount.dataset.branchFilter;
    if (filterKey && params.get(filterKey)) {
      if (!readBranch()) writeBranch({ handle: params.get(filterKey), name: params.get(filterKey) });
      return;
    }

    if (readBranch()) return;
    window.location.replace(localizedPath(page));
  }
  gateOnLoad();

  /* gateOnLoad only catches visitors with no branch yet. Once one is chosen it
     steps aside - and every product list reached without the filter parameter
     then shows every branch's stock underneath a header naming just one.
     Measured on this store: with Marilyn Collection chosen (6 products),
     /collections/all listed all 16, and a search for "monstera" returned 15.
     Any plain link gets there - the footer, the category cards, a shared or
     bookmarked URL - because the filter only ever rides the URL the branch
     picker itself builds.

     Shopify resolves the faceted filter from the URL before the page renders,
     so a page that arrived unfiltered cannot re-filter itself; the URL is
     corrected instead. location.replace keeps the unfiltered URL out of
     history so Back does not bounce through it. */
  function filterOnLoad() {
    if (!branchMount) return;
    var filterKey = branchMount.dataset.branchFilter;
    if (!filterKey) return;
    var branch = readBranch();
    if (!branch || !branch.handle) return;

    /* Collections list products this filter narrows. Product pages and the
       collection index do not, so they are left alone. Search is left alone
       too: it filters by branch in the page instead (searchBranchFilter),
       because Shopify's French filter index drops results there. */
    var here = window.location.pathname;
    var listsProducts = here.indexOf("/collections/") !== -1;
    if (!listsProducts) return;

    var url;
    try { url = new URL(window.location.href) } catch (e) { return }
    /* Only when the parameter is absent. An explicitly empty value is a
       deliberate "show me everything" and is left as it is. */
    if (url.searchParams.get(filterKey) !== null) return;

    url.searchParams.set(filterKey, branch.handle);
    window.location.replace(url.toString());
  }
  filterOnLoad();

  /* Back/forward cache (Safari on iPhone especially) restores a page exactly
     as it was left, without re-running any of the above. Switching branch
     and then going Back could show the old branch's products under the new
     branch's name in the header. If the remembered branch changed since this
     page was built, rebuild it. */
  var branchAtLoad = (readBranch() || {}).handle || "";
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    if (((readBranch() || {}).handle || "") !== branchAtLoad) window.location.reload();
  });

  /* Whether n takes the singular in the page's language - French uses it
     for 0 as well as 1 ("0 résultat"), English only for 1. */
  function pluralOne(n) {
    try { return new Intl.PluralRules(document.documentElement.lang || "en").select(n) === "one" }
    catch (e) { return n === 1 }
  }

  /* --- branch filtering across pages ---------------------------------------
     Shopify's French filter index is incomplete (collections and search both
     lost products through it), so where it cannot be trusted the theme
     filters by branch itself, from each product card's data-branches.

     A filter that only looks at the page on screen gets pagination wrong:
     page 1 of the unfiltered list is not page 1 of the filtered one. So
     when the unfiltered list runs to more than one page, every page is
     fetched (Section Rendering API - the section alone, not the whole
     page), the matching cards are gathered in Shopify's own sort order, and
     this paginates them itself at the same page size, with its own page
     links. One page needs no fetching at all. If a fetch fails, the
     shopper keeps the unfiltered page and opts.onFail explains. */
  function branchPaginate(opts) {
    var branch = readBranch();
    if (!branch) return false;
    var grid = opts.grid;
    if (!grid) return false;
    var want = branch.handle.trim();
    var perPage = parseInt(opts.scope.dataset.perPage, 10) || 24;
    var pages = parseInt(opts.scope.dataset.pages, 10) || 1;
    var sectionId = opts.scope.dataset.sectionId;
    var here = new URL(window.location.href);
    var current = Math.max(1, parseInt(here.searchParams.get("page"), 10) || 1);
    var labels = { prev: "«", next: "»", aria: "" };

    function matches(card) {
      if (!card.hasAttribute("data-branches")) return !!opts.keepUnbranched;
      return card.getAttribute("data-branches").split("|")
        .map(function (v) { return v.trim() }).indexOf(want) !== -1;
    }

    function readLabels(doc) {
      var nav = doc.querySelector(".pagination");
      if (!nav) return;
      if (nav.getAttribute("aria-label")) labels.aria = nav.getAttribute("aria-label");
      var prev = nav.querySelector(".prev a"), next = nav.querySelector(".next a");
      if (prev) labels.prev = prev.textContent.trim();
      if (next) labels.next = next.textContent.trim();
    }

    function pageUrl(n) {
      var u = new URL(window.location.href);
      u.searchParams.delete("section_id");
      if (n > 1) u.searchParams.set("page", n); else u.searchParams.delete("page");
      return u.pathname + u.search;
    }

    function span(cls, text, href) {
      var el = document.createElement("span");
      el.className = cls;
      if (href) {
        var a = document.createElement("a");
        a.href = href;
        a.textContent = text;
        el.appendChild(a);
      } else el.textContent = text;
      return el;
    }

    function buildNav(page, total) {
      var nav = document.createElement("nav");
      nav.className = "pagination";
      if (labels.aria) nav.setAttribute("aria-label", labels.aria);
      if (page > 1) nav.appendChild(span("prev", labels.prev, pageUrl(page - 1)));
      for (var n = 1; n <= total; n++) {
        nav.appendChild(document.createTextNode(" "));
        nav.appendChild(n === page ? span("page current", String(n)) : span("page", String(n), pageUrl(n)));
      }
      if (page < total) {
        nav.appendChild(document.createTextNode(" "));
        nav.appendChild(span("next", labels.next, pageUrl(page + 1)));
      }
      return nav;
    }

    function render(cards) {
      var hits = cards.filter(matches);
      var total = Math.max(1, Math.ceil(hits.length / perPage));
      var page = Math.min(current, total);
      Array.prototype.slice.call(grid.children).forEach(function (child) {
        if (child.matches(".product, .pagination")) child.remove();
      });
      hits.slice((page - 1) * perPage, page * perPage).forEach(function (card) {
        card.style.display = "";
        grid.appendChild(card);
      });
      if (total > 1) grid.appendChild(buildNav(page, total));
      if (page !== current) {
        try { history.replaceState(null, "", pageUrl(page)) } catch (e) { /* ignore */ }
      }
      opts.onCount(hits.length);
      syncFavoriteButtons();
    }

    readLabels(document);
    var onScreen = Array.prototype.slice.call(grid.querySelectorAll(":scope > .product"));
    if (pages <= 1 || !sectionId) {
      render(onScreen);
      return true;
    }

    grid.setAttribute("aria-busy", "true");
    grid.style.visibility = "hidden";
    var requests = [];
    for (var p = 1; p <= pages; p++) {
      var u = new URL(window.location.href);
      u.searchParams.set("page", p);
      u.searchParams.set("section_id", sectionId);
      requests.push(fetch(u.toString(), { credentials: "same-origin" }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }));
    }
    Promise.all(requests).then(function (htmls) {
      var all = [];
      htmls.forEach(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var g = doc.querySelector(opts.gridSelector);
        if (!g) throw new Error("grid missing");
        readLabels(doc);
        Array.prototype.forEach.call(g.querySelectorAll(":scope > .product"), function (card) {
          all.push(document.importNode(card, true));
        });
      });
      render(all);
    }).catch(function () {
      if (opts.onFail) opts.onFail();
    }).then(function () {
      grid.style.visibility = "";
      grid.removeAttribute("aria-busy");
    });
    return true;
  }

  /* Search never sends the branch filter to Shopify (see branchPaginate):
     a search for "monstera" came back 34 results in French against 47 in
     English through it. Pages and articles in the results carry no
     data-branches and are always kept. A branch parameter left on the URL
     by old links or bookmarks is dropped first, so Shopify's index never
     narrows the results before this sees them. */
  function searchBranchFilter() {
    var scope = document.getElementById("SearchResults");
    if (!scope) return;
    var filterKey = branchMount && branchMount.dataset.branchFilter;
    if (filterKey) {
      var url;
      try { url = new URL(window.location.href) } catch (e) { return }
      if (url.searchParams.has(filterKey)) {
        url.searchParams.delete(filterKey);
        window.location.replace(url.toString());
        return;
      }
    }
    branchPaginate({
      scope: scope,
      grid: scope.querySelector("[data-search-grid]"),
      gridSelector: "[data-search-grid]",
      keepUnbranched: true,
      onCount: function (n) {
        var heading = scope.querySelector("[data-search-count]");
        var tpl = pluralOne(n) ? T.search_one : T.search_other;
        if (heading && tpl) heading.textContent = tpl.replace(/[0-9]+/, n);
        var empty = scope.querySelector("[data-search-client-empty]");
        if (empty) empty.hidden = n !== 0;
      }
    });
  }
  searchBranchFilter();

  /* Collection pages: branchPaginate over #ProductGrid, run only in the
     branch_all state branchFilterFallback() below sets up. Returns false
     when there is no remembered branch to filter by. */
  function clientBranchFilter(scope, note) {
    var grid = document.getElementById("ProductGrid");
    return branchPaginate({
      scope: scope,
      grid: grid,
      gridSelector: "#ProductGrid",
      keepUnbranched: false,
      onCount: function (n) {
        var count = scope.querySelector(".toolbar-count");
        var tpl = pluralOne(n) ? T.count_one : T.count_other;
        if (count && tpl) count.textContent = tpl.replace(/[0-9]+/, n);
        var empty = grid && grid.parentNode.querySelector("[data-client-empty]");
        if (n === 0 && grid && T.collection_empty) {
          if (!empty) {
            empty = document.createElement("p");
            empty.className = "empty";
            empty.setAttribute("data-client-empty", "");
            empty.textContent = T.collection_empty;
            grid.parentNode.insertBefore(empty, grid.nextSibling);
          }
        } else if (empty) { empty.remove(); }
      },
      onFail: function () {
        if (note && T.branch_filter_unavailable) {
          note.textContent = T.branch_filter_unavailable;
          note.hidden = false;
        }
      }
    });
  }

/* The branch filter turning up empty-handed is normally just a branch
     without this collection's stock. main-collection.liquid marks the one
     case where that answer cannot be trusted - Shopify's filter index
     reporting zero for every branch while the collection plainly holds
     products - and this drops the branch from the URL there, leaving the
     already-understood empty value in its place. Better a shopper loses a
     filter than the whole shop. Heals itself: once the index reports
     counts again the marker stops being rendered. */
  function branchFilterFallback() {
    var scope = document.getElementById("MainCollection");
    if (!scope) return;
    var note = scope.querySelector("[data-filter-fallback-note]");

    var url;
    try { url = new URL(window.location.href) } catch (e) { return }

    if (url.searchParams.get("branch_all") === "1") {
      /* Shopify's index cannot filter here, so filter by the remembered
         branch ourselves, straight from each card's own metafield. Only when
         no branch is remembered do we fall back to the plain notice. */
      if (!clientBranchFilter(scope, note) && note && T.branch_filter_unavailable) {
        note.textContent = T.branch_filter_unavailable;
        note.hidden = false;
      }
      return;
    }

    var filterKey = scope.dataset.branchParam;
    if (!filterKey) return;
    var applied = url.searchParams.get(filterKey);
    if (!applied) return;

    var total = parseInt(scope.dataset.collectionTotal, 10);
    var counted = parseInt(scope.dataset.branchFilterTotal, 10);
    /* counted sums every product the facet index has caught up on, across
       all branches, so it only ever reaches "total" once every product is
       indexed for this locale. New uploads showed up in the index straight
       away in English but took the French index a day or two to catch up,
       during which counted sat below total (e.g. 34 of 44) instead of at
       -1/0 - a partial version of the same dead-index problem, not a
       separate one. Comparing against the real total instead of demanding
       zero catches that half-caught-up state too, and still leaves an
       honestly-empty branch (counted === total, this branch just has none)
       alone. */
    if (!(total > 0) || counted >= total) return;

    url.searchParams.set(filterKey, "");
    url.searchParams.set("branch_all", "1");
    window.location.replace(url.toString());
  }
  branchFilterFallback();

  /* The branch actually on screen, read from the URL rather than from
     collection.filters. Apply/Sort/Clear all all try to mirror the branch
     as a hidden field or a query string from collection.filters' own
     active_values - which works until the collection's result set is
     already empty, at which point Shopify drops that facet from
     collection.filters entirely and there is nothing left there to mirror.
     Submitting from that state dropped the branch outright; filterOnLoad()
     then caught the branch missing on the page that loaded and forced a
     second, unexplained reload to add it back - two reloads that landed
     back on the same empty collection, which is what looked broken. The
     URL is true regardless of what Shopify put in collection.filters, so
     read it from there instead. */
  function currentBranchParam() {
    if (!branchMount) return null;
    var filterKey = branchMount.dataset.branchFilter;
    if (!filterKey) return null;
    var value = new URLSearchParams(window.location.search).get(filterKey);
    return value === null ? null : { key: filterKey, value: value };
  }

  function ensureBranchParam(form) {
    var branch = currentBranchParam();
    if (!branch || !form) return;
    var input = form.querySelector('input[name="' + branch.key + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = branch.key;
      form.appendChild(input);
    }
    input.value = branch.value;
    if (new URLSearchParams(window.location.search).get("branch_all") === "1") {
      var flag = form.querySelector('input[name="branch_all"]');
      if (!flag) {
        flag = document.createElement("input");
        flag.type = "hidden";
        flag.name = "branch_all";
        form.appendChild(flag);
      }
      flag.value = "1";
    }
  }

  /* "Shop" in the primary nav always returns to the branch page, even when a
     branch is already chosen - asked for explicitly ("กด shop ไม่ว่าจะกรณีใดๆ
     ต้อง อยู่หน้าเลือกสาขา"). The gate alone only catches a first visit.

     Matched by URL rather than by link title, which is merchant-set and
     translated. Scoped to .site-nav on purpose: "continue shopping" and
     empty-state buttons point at the same collection, and sending someone
     mid-purchase back to pick a branch again would be a step backwards. */
  document.addEventListener("click", function (e) {
    if (!branchMount || branchMount.dataset.gate !== "on") return;
    var page = branchMount.dataset.branchPage;
    var shopUrl = branchMount.dataset.branchShopUrl;
    if (!page || !shopUrl) return;

    var link = e.target.closest(".site-nav a");
    if (!link) return;

    var href = link.getAttribute("href") || "";
    var path = href.split("?")[0].split("#")[0].replace(/\/+$/, "");
    if (path !== shopUrl.replace(/\/+$/, "")) return;

    e.preventDefault();
    window.location.href = localizedPath(page);
  });

  /* --- auto-submit --------------------------------------------------------
     The sort <select> carries data-auto-submit and nothing ever listened
     for it, so choosing an option changed the control but never touched
     the URL or the results underneath it - the sort silently did nothing.

     form.submit() is called directly rather than form.requestSubmit(),
     which is the one thing on this element that still needs a fix: the
     plain .submit() method does not fire a "submit" event at all, so a
     listener on that event - which is where ensureBranchParam runs for
     the Apply form below - would never see this one. Called here instead,
     right before the submit that only .change gets to hear about. */
  document.addEventListener("change", function (e) {
    var el = e.target.closest("[data-auto-submit]");
    if (!el || !el.form) return;
    ensureBranchParam(el.form);
    el.form.submit();
  });

  /* --- clicks ------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    /* The drawer's Checkout is a plain <a>, which has no disabled state of
       its own to lean on - aria-disabled only describes it, it does not
       stop the click. */
    var checkoutBlocked = e.target.closest('[data-checkout-button][aria-disabled="true"]');
    if (checkoutBlocked) { e.preventDefault(); return }

    /* Both "Clear all" links on a collection page - the one beside Apply
       and the one in the empty-products message - rewritten from the
       branch actually on screen right before the click is followed. See
       the note above ensureBranchParam for why collection.filters is not
       enough on its own here. Not prevented: the (possibly rewritten) href
       navigates exactly as a plain link would. */
    var clearLink = e.target.closest('[data-collection-clear]');
    if (clearLink) {
      var clearBranch = currentBranchParam();
      if (clearBranch) {
        try {
          var clearUrl = new URL(clearLink.href, window.location.href);
          clearUrl.searchParams.set(clearBranch.key, clearBranch.value);
          if (new URLSearchParams(window.location.search).get("branch_all") === "1") {
            clearUrl.searchParams.set("branch_all", "1");
          }
          clearLink.href = clearUrl.toString();
        } catch (err) { /* malformed href: leave it as Liquid rendered it */ }
      }
      return;
    }

    var toggle = e.target.closest('.menu-toggle');
    if (toggle) { setMenu(toggle.getAttribute('aria-expanded') !== 'true'); return }

    /* Below 1025px .filters is display:none until this class lands - the
       toggle button rendered but nothing ever added it, so filtering the
       collection was unreachable on any phone or tablet. */
    var filterToggle = e.target.closest(".filter-toggle");
    if (filterToggle) {
      var panel = document.getElementById(filterToggle.getAttribute("aria-controls"));
      if (panel) {
        var willOpen = !panel.classList.contains("is-open");
        panel.classList.toggle("is-open", willOpen);
        filterToggle.setAttribute("aria-expanded", String(willOpen));
      }
      return;
    }

    if (e.target.closest("[data-branch-open]")) {
      e.preventDefault();
      setDrawer(branchDrawer, true);
      return;
    }

    var pick = e.target.closest("[data-branch-choose]");
    if (pick) {
      writeBranch({ handle: pick.dataset.branchHandle, name: pick.dataset.branchName });
      announce(T.branch_selected ? T.branch_selected.replace("{{ name }}", pick.dataset.branchName) : "");
      closeAllDrawers();
      return; /* the anchor navigates to the branch collection */
    }

    /* Shop is the way into the branch chooser, so it always asks, even when
       a branch is already set. Any other route to products only asks while
       nothing has been chosen yet. */
    var shopLink = e.target.closest("a[href]");
    if (shopLink && branchMount && branchMount.dataset.gate === "on") {
      var href = shopLink.getAttribute("href") || "";
      var page = branchMount.dataset.branchPage;
      var path = href.split("?")[0];
      var query = href.indexOf("?") === -1 ? "" : href.slice(href.indexOf("?"));
      var goesToProducts = path.indexOf("/collections") !== -1 || path.indexOf("/products") !== -1;
      var isShopAll = path.indexOf("/collections/all") !== -1 &&
        query.indexOf(branchMount.dataset.branchFilter || "__none__") === -1;

      if (page && href.indexOf(page) === -1 && goesToProducts && (isShopAll || !readBranch())) {
        e.preventDefault();
        window.location.href = localizedPath(page);
        return;
      }
    }

    var fav = e.target.closest('[data-fav]');
    if (fav) { e.preventDefault(); toggleFavorite(fav.dataset.fav); return }

    if (e.target.closest('[data-favorites-open]')) {
      e.preventDefault();
      renderFavorites();
      setDrawer(favDrawer, true);
      return;
    }

    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      if (!cartDrawer) { window.location.href = rootUrl + 'cart'; return }
      fetchCart(true);
      return;
    }

    if (e.target.closest('[data-drawer-close]') || e.target.closest('.drawer-scrim')) {
      closeAllDrawers();
      return;
    }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var field = step.parentElement.querySelector('input');
      var stepMax = field.max !== '' ? parseInt(field.max, 10) : Infinity;
      var stepNext = (parseInt(field.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10);
      field.value = Math.min(stepMax, Math.max(1, stepNext));
      field.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    /* The thumbnail rail rendered aria-current and everything showMedia()
       needs, but nothing ever called it on a manual click - only a variant
       change did, so with no variants (or same-media variants) the extra
       photos were unreachable. */
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      showMedia(productScope(), thumb.dataset.thumb);
      return;
    }

    var lineStep = e.target.closest('[data-line-change]');
    if (lineStep) {
      var row = lineStep.closest('[data-key]');
      var input = row.querySelector('[data-line-qty]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(lineStep.dataset.lineChange, 10));
      changeLine(row.dataset.key, next);
      return;
    }

    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.closest('[data-key]').dataset.key, 0);
    }
  });

  document.addEventListener('change', function (e) {
    var localeSelect = e.target.closest('[data-locale-select]');
    if (localeSelect) { localeSelect.form.submit(); return }

    var intent = e.target.closest('[data-fulfillment-intent]');
    if (intent) {
      var root = intent.closest('#CartDrawer') || intent.closest('section') || document;
      updateCheckoutGate(root);
      return;
    }

    var lineQty = e.target.closest('[data-line-qty]');
    if (lineQty) {
      changeLine(lineQty.closest('[data-key]').dataset.key, Math.max(0, parseInt(lineQty.value, 10) || 0));
      return;
    }

    /* Typed values bypass the stepper buttons, so <input max> alone does not
       stop someone from ordering more than is actually in stock - the
       attribute affects the spinner and validity state but not the value
       itself. */
    if (e.target.id === 'Quantity') {
      var qtyField = e.target;
      var qtyMax = qtyField.max !== '' ? parseInt(qtyField.max, 10) : Infinity;
      var qtyValue = Math.min(qtyMax, Math.max(1, parseInt(qtyField.value, 10) || 1));
      if (String(qtyValue) !== qtyField.value) qtyField.value = qtyValue;
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openDrawer) { closeAllDrawers(); return }
      if (nav && nav.classList.contains('is-open')) setMenu(false);
      return;
    }
    if (e.key !== 'Tab') return;
    var container = openDrawer ? openDrawer.querySelector('.drawer-panel')
      : (nav && nav.classList.contains('is-open') ? nav : null);
    if (!container) return;
    var items = visibleFocusable(container);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus() }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus() }
  });

  /* --- add to cart -------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;

    /* Apply, on the collection/search filter form: a real user-triggered
       submit, so unlike the sort <select> above this one does fire the
       submit event on its own. Not prevented - the native GET submission
       is what these filters have always run on - just given the branch to
       carry, per the note above ensureBranchParam. */
    if (form.matches('#CollectionFilters')) { ensureBranchParam(form); return }

    /* The product page form carries its own class so the card button styling
       does not apply to it; both still add through the cart API. */
    if (!form.matches('.product-form, .product-form-main')) return;
    e.preventDefault();
    var button = form.querySelector('[type=submit]');
    if (!button || button.disabled) return;

    var label = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = T.adding || '';

    fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().catch(function () { return {} }).then(function (err) {
          throw new Error(err.description || err.message || r.statusText);
        });
      })
      .then(function () {
        button.classList.add('is-done');
        button.textContent = (T.added || '') + ' ✓';
        announce(T.added || '');
        return fetchCart(true);
      })
      .catch(function (err) {
        button.classList.add('is-error');
        button.textContent = String(err.message || T.try_again || '').slice(0, 42);
        announce(String(err.message || ''));
      })
      .then(function () {
        window.setTimeout(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.classList.remove('is-done', 'is-error');
          button.textContent = label;
        }, 1800);
      });
  });

  /* --- product options ----------------------------------------------------
     Match the chosen option values against the variant list rather than
     binding one select to variant ids, so multi-option products work and the
     URL, media, price, stock and button all follow the selection. */
  function productScope() { return document.querySelector('[data-product]') }

  function readJSON(scope, selector) {
    var el = scope.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent) } catch (e) { return null }
  }

  function showMedia(scope, mediaId) {
    if (!mediaId) return;
    var items = scope.querySelectorAll('[data-media-id]');
    Array.prototype.forEach.call(items, function (el) {
      el.classList.toggle('is-current', String(el.dataset.mediaId) === String(mediaId));
    });
    var target = scope.querySelector('[data-media-id="' + mediaId + '"]');
    if (target && items.length > 1) target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-thumb]'), function (b) {
      b.setAttribute('aria-current', String(String(b.dataset.thumb) === String(mediaId)));
    });
  }

  function applyVariant(scope, variant) {
    var labels = readJSON(scope, '[data-product-labels]') || {};
    var price = scope.querySelector('[data-variant-price]');
    var button = scope.querySelector('[data-add-button]');
    var idField = scope.querySelector('[data-variant-id]');
    var stock = scope.querySelector('[data-stock]');
    var sku = scope.querySelector('[data-sku]');
    var qtyField = scope.querySelector('#Quantity');

    if (!variant) {
      if (button) { button.disabled = true; button.textContent = labels.unavailable || '' }
      if (price) price.textContent = '';
      return;
    }

    if (idField) idField.value = variant.id;

    if (price) {
      var money = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        price.innerHTML = '<span class="on-sale">' + escapeHtml(money) + '</span> <s>' +
          escapeHtml(formatMoney(variant.compare_at_price)) + '</s>';
      } else {
        price.textContent = money;
      }
    }

    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? labels.add : labels.sold_out;
    }

    if (stock) {
      var dot = '<span class="dot' + (variant.available ? '' : ' is-out') + '" aria-hidden="true"></span> ';
      stock.innerHTML = dot + escapeHtml(variant.available ? labels.in_stock : labels.sold_out);
    }

    if (sku) sku.textContent = variant.sku || '';
    if (variant.featured_media) showMedia(scope, variant.featured_media.id);

    if (qtyField) {
      var inventory = readJSON(scope, '[data-variant-inventory]') || {};
      var newMax = inventory[String(variant.id)];
      if (newMax == null) {
        qtyField.removeAttribute('max');
      } else {
        qtyField.setAttribute('max', newMax);
        if ((parseInt(qtyField.value, 10) || 1) > newMax) qtyField.value = Math.max(1, newMax);
      }
    }

    /* keep the address bar shareable without adding history entries */
    var base = scope.dataset.url;
    if (base && window.history && window.history.replaceState) {
      window.history.replaceState({}, '', base + '?variant=' + variant.id);
    }
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
  }

  function selectedOptions(scope) {
    return Array.prototype.map.call(scope.querySelectorAll('[data-option-index]'), function (sel) {
      return sel.value;
    });
  }

  function matchVariant(scope) {
    var variants = readJSON(scope, '[data-variant-json]');
    if (!variants) return null;
    var chosen = selectedOptions(scope);
    if (!chosen.length) return variants[0];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var same = true;
      for (var k = 0; k < chosen.length; k++) {
        if (v.options[k] !== chosen[k]) { same = false; break }
      }
      if (same) return v;
    }
    return null;
  }

  function initProduct() {
    var scope = productScope();
    if (!scope) return;
    var variants = readJSON(scope, '[data-variant-json]');
    if (!variants || !variants.length) return;

    /* honour ?variant= on load so shared links open the right one */
    var wanted = new URLSearchParams(window.location.search).get('variant');
    if (wanted) {
      var found = variants.filter(function (v) { return String(v.id) === String(wanted) })[0];
      if (found) {
        Array.prototype.forEach.call(scope.querySelectorAll('[data-option-index]'), function (sel) {
          var val = found.options[Number(sel.dataset.optionIndex)];
          if (val != null) sel.value = val;
        });
        applyVariant(scope, found);
      }
    }
  }
  initProduct();
  document.addEventListener('shopify:section:load', initProduct);

  /* --- product recommendations (Shopify renders the section) -------------- */
  function loadRecommendations() {
    var host = document.querySelector('[data-recommendations]');
    if (!host || host.dataset.loaded) return;
    host.dataset.loaded = '1';
    fetch(host.dataset.url)
      .then(function (r) { return r.ok ? r.text() : '' })
      .then(function (html) {
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          host.innerHTML = fresh.innerHTML;
          initReveal();
          syncFavoriteButtons();
        }
      })
      .catch(function () { /* recommendations are optional */ });
  }
  if (document.querySelector('[data-recommendations]')) {
    if ('IntersectionObserver' in window) {
      var recObserver = new IntersectionObserver(function (entries, obs) {
        if (entries.some(function (e) { return e.isIntersecting })) { loadRecommendations(); obs.disconnect() }
      }, { rootMargin: '400px' });
      recObserver.observe(document.querySelector('[data-recommendations]'));
    } else loadRecommendations();
  }

  /* --- predictive search --------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-predictive-search]'), function (wrap) {
    var input = wrap.querySelector('[data-predictive-input]');
    var panel = wrap.querySelector('[data-predictive-results]');
    var status = wrap.querySelector('[data-predictive-status]');
    if (!input || !panel) return;

    var timer = null;
    var controller = null;

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function options() {
      return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
    }

    function move(step) {
      var items = options();
      if (!items.length) return;
      var at = items.indexOf(document.activeElement);
      var next = at + step;
      if (next < 0) next = items.length - 1;
      if (next >= items.length) next = 0;
      items[next].focus();
    }

    function run(term) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = wrap.dataset.url + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,article,page&resources[limit]=4&section_id=predictive-search';
      if (status) status.textContent = T.searching || '';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.ok ? r.text() : '' })
        .then(function (html) {
          if (!html) return close();
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var body = parsed.querySelector('.ps-groups, .ps-empty');
          panel.innerHTML = body ? parsed.body.innerHTML : '';
          panel.hidden = !panel.innerHTML.trim();
          input.setAttribute('aria-expanded', String(!panel.hidden));
          if (status) status.textContent = panel.querySelectorAll('[role="option"]').length + '';
        })
        .catch(function (err) { if (err.name !== 'AbortError') close() });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      window.clearTimeout(timer);
      if (term.length < 2) { close(); return }
      timer = window.setTimeout(function () { run(term) }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.blur(); return }
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1) }
      if (e.key === 'ArrowUp') { e.preventDefault(); move(-1) }
    });

    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); return }
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1) }
      if (e.key === 'ArrowUp') { e.preventDefault(); move(-1) }
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
  });

  /* --- hero slideshow ------------------------------------------------------
     Crossfades the cover images. It never autoplays under reduced motion, and
     it stops while the tab is hidden or the shopper is interacting with it. */
  function initHeroSlider() {
    var hero = document.querySelector('[data-hero-slider]');
    if (!hero || hero.dataset.ready) return;
    var slides = hero.querySelectorAll('.hero-slide');
    if (slides.length < 2) return;
    hero.dataset.ready = '1';

    var dots = hero.querySelectorAll('[data-hero-dot]');
    var pause = hero.querySelector('[data-hero-pause]');
    var status = hero.querySelector('[data-hero-status]');
    var interval = parseInt(hero.dataset.interval, 10) || 0;
    var at = 0;
    var timer = null;
    var stopped = reduceMotion.matches || interval === 0;

    function show(next) {
      at = (next + slides.length) % slides.length;
      Array.prototype.forEach.call(slides, function (s, i) {
        s.classList.toggle('is-active', i === at);
      });
      Array.prototype.forEach.call(dots, function (d, i) {
        d.classList.toggle('is-active', i === at);
        d.setAttribute('aria-selected', String(i === at));
      });
      if (status && T.hero_slide_of) {
        status.textContent = T.hero_slide_of
          .replace('{{ index }}', at + 1)
          .replace('{{ total }}', slides.length);
      }
    }

    function start() {
      if (stopped || timer) return;
      timer = window.setInterval(function () { show(at + 1) }, interval);
    }

    function halt() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        show(Number(dot.dataset.heroDot));
        halt();
        start();
      });
    });

    if (pause) {
      pause.setAttribute('aria-pressed', String(stopped));
      pause.setAttribute('aria-label', stopped ? (T.hero_play || '') : (T.hero_pause || ''));
      pause.addEventListener('click', function () {
        stopped = !stopped;
        pause.setAttribute('aria-pressed', String(stopped));
        pause.setAttribute('aria-label', stopped ? (T.hero_play || '') : (T.hero_pause || ''));
        if (stopped) halt(); else start();
      });
    }

    /* Interacting with the hero should not fight the timer. */
    hero.addEventListener('mouseenter', halt);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', halt);
    hero.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) halt(); else start();
    });
    reduceMotion.addEventListener('change', function (e) {
      stopped = e.matches;
      if (stopped) halt(); else start();
    });

    start();
  }
  initHeroSlider();
  document.addEventListener('shopify:section:load', initHeroSlider);

  /* --- trust bar overlap ----------------------------------------------------
     The bar is pulled up over the hero by --trust-h, which shipped as a
     hardcoded 88px guess at its own height. Whenever the real height comes
     in under that — a wrapped label, a browser zoom, a fractional device
     pixel — the shortfall shows as a strip of hero photograph below the bar;
     at 87.4px that is a 0.6px hairline right across the page. Measure the
     bar and let it set its own overlap. Floor it, so the bar always reaches
     the bottom of the hero rather than stopping short of it. */
  function syncTrustHeight() {
    var trust = document.querySelector('.trust');
    if (!trust) return;
    var h = trust.getBoundingClientRect().height;
    if (h > 0) document.documentElement.style.setProperty('--trust-h', Math.floor(h) + 'px');
  }
  syncTrustHeight();
  document.addEventListener('shopify:section:load', syncTrustHeight);
  if (window.ResizeObserver) {
    var trustBar = document.querySelector('.trust');
    if (trustBar) new ResizeObserver(syncTrustHeight).observe(trustBar);
  } else {
    window.addEventListener('resize', syncTrustHeight, { passive: true });
  }

  /* --- why grow with us ----------------------------------------------------
     Desktop keeps every reason open beside the plant; below 900px they behave
     as a one-at-a-time accordion. The plant drifts with the pointer, never
     under reduced motion. */
  function initWhy() {
    var stage = document.querySelector("[data-why-stage]");
    if (!stage || stage.dataset.ready) return;
    stage.dataset.ready = "1";

    var cards = Array.prototype.slice.call(stage.querySelectorAll("[data-why-card]"));
    var plant = stage.querySelector("[data-why-parallax]");
    var narrow = window.matchMedia("(max-width: 900px)");
    var hoverable = window.matchMedia("(hover: hover)");
    var RESTING = 0;
    var hoverTimer = null;

    function openOnly(index) {
      cards.forEach(function (card, i) { card.open = i === index });
    }

    function applyMode() {
      if (narrow.matches) openOnly(0);
      else openOnly(RESTING);
    }
    applyMode();
    narrow.addEventListener("change", applyMode);

    /* On a pointer device the reasons read themselves as you move across
       them, and the section falls back to the first one when you leave, so
       it is never sitting empty. */
    cards.forEach(function (card, i) {
      function reveal() {
        if (narrow.matches || !hoverable.matches) return;
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () { openOnly(i) }, 90);
      }
      card.addEventListener("mouseenter", reveal);
      card.addEventListener("focusin", function () {
        if (narrow.matches) return;
        window.clearTimeout(hoverTimer);
        openOnly(i);
      });

      /* Touch and keyboard still toggle, one at a time. */
      card.addEventListener("toggle", function () {
        if (!card.open) return;
        cards.forEach(function (other) { if (other !== card) other.open = false });
      });
    });

    stage.addEventListener("mouseleave", function () {
      window.clearTimeout(hoverTimer);
      if (!narrow.matches && hoverable.matches) openOnly(RESTING);
      if (plant) plant.style.transform = "";
    });

    /* A single hairline from the open reason to a point on the plant, drawn
       the way a botanical plate annotates a specimen. Only ever one at a
       time — four at once reads as a diagram, not a photograph. */
    var links = stage.querySelector('[data-why-links]');
    var anchors = [
      { x: 0.30, y: 0.26 },
      { x: 0.72, y: 0.20 },
      { x: 0.34, y: 0.70 },
      { x: 0.68, y: 0.58 }
    ];

    function drawLink(index) {
      if (!links) return;
      links.innerHTML = '';
      if (narrow.matches || index == null) return;

      var card = cards[index];
      var anchor = anchors[index] || anchors[0];
      var stageBox = stage.getBoundingClientRect();
      var pillBox = card.querySelector('summary').getBoundingClientRect();
      var plantBox = (plant || stage).getBoundingClientRect();

      links.setAttribute('viewBox', '0 0 ' + stageBox.width + ' ' + stageBox.height);

      var target = {
        x: plantBox.left - stageBox.left + plantBox.width * anchor.x,
        y: plantBox.top - stageBox.top + plantBox.height * anchor.y
      };
      /* Leave from whichever end of the pill faces the plant. */
      var pillMidY = pillBox.top - stageBox.top + pillBox.height / 2;
      var leavesRight = (pillBox.left + pillBox.right) / 2 < plantBox.left + plantBox.width / 2;
      var start = {
        x: (leavesRight ? pillBox.right : pillBox.left) - stageBox.left,
        y: pillMidY
      };

      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      var midX = (start.x + target.x) / 2;
      var d = 'M ' + start.x + ' ' + start.y +
              ' C ' + midX + ' ' + start.y + ', ' + midX + ' ' + target.y +
              ', ' + target.x + ' ' + target.y;
      path.setAttribute('d', d);
      links.appendChild(path);

      var dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      dot.setAttribute('cx', target.x);
      dot.setAttribute('cy', target.y);
      dot.setAttribute('r', 3.2);
      links.appendChild(dot);

      var length = path.getTotalLength();
      path.style.setProperty('--len', length);
      /* Force a frame so the dash offset animates from its full length. */
      void path.getBoundingClientRect();
      path.classList.add('is-drawn');
      dot.classList.add('is-drawn');
    }

    function openIndex() {
      for (var i = 0; i < cards.length; i++) if (cards[i].open) return i;
      return null;
    }

    var redraw = function () { drawLink(openIndex()) };
    cards.forEach(function (card) { card.addEventListener('toggle', redraw) });
    window.addEventListener('resize', function () {
      window.clearTimeout(links && links.dataset.t);
      redraw();
    }, { passive: true });
    redraw();

    if (!plant) return;
    var raf = null;
    stage.addEventListener("mousemove", function (e) {
      if (reduceMotion.matches || narrow.matches) return;
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        var box = stage.getBoundingClientRect();
        var x = (e.clientX - box.left) / box.width - 0.5;
        var y = (e.clientY - box.top) / box.height - 0.5;
        plant.style.transform = "translate3d(" + (x * 18).toFixed(1) + "px," + (y * 12).toFixed(1) + "px,0)";
      });
    });
  }
  initWhy();
  document.addEventListener('shopify:section:load', initWhy);

  /* --- review list ---------------------------------------------------------
     Filtering, sorting and paging run here rather than through the server:
     every review Judge.me publishes is already on the page, so narrowing to
     four-star reviews is a matter of hiding rows, and a round trip would only
     cost the reader time. With no JS the list still renders, in full and
     unfiltered, which is the honest fallback for a page whose whole job is to
     show the reviews. */
  function initReviewList() {
    var root = document.querySelector('[data-review-root]');
    if (!root) return;
    var list = root.querySelector('[data-review-list]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-review-item]'));
    if (!list || !items.length) return;

    var empty = root.querySelector('[data-review-empty]');
    var more = root.querySelector('[data-review-more]');
    var clear = root.querySelector('[data-review-clear]');
    var sorter = root.querySelector('[data-review-sort]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-review-filter]'));
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-review-product]'));

    var batch = 8;
    var config = root.querySelector('[data-review-config]');
    if (config) { try { batch = JSON.parse(config.textContent).batch || batch } catch (e) {} }
    var shown = batch;
    var mode = 'all';

    function chosenProducts() {
      var out = [];
      boxes.forEach(function (b) { if (b.checked) out.push(b.getAttribute('data-review-product')) });
      return out;
    }

    function matches(item) {
      var products = chosenProducts();
      if (products.length && products.indexOf(item.getAttribute('data-product')) === -1) return false;
      if (mode === 'all') return true;
      if (mode === 'photos') return item.getAttribute('data-photo') === 'true';
      return item.getAttribute('data-rating') === mode;
    }

    function order(a, b) {
      var how = sorter ? sorter.value : 'recent';
      var da = Date.parse(a.getAttribute('data-date')) || 0;
      var db = Date.parse(b.getAttribute('data-date')) || 0;
      var ra = parseInt(a.getAttribute('data-rating'), 10) || 0;
      var rb = parseInt(b.getAttribute('data-rating'), 10) || 0;
      if (how === 'oldest') return da - db;
      if (how === 'highest') return rb - ra || db - da;
      if (how === 'lowest') return ra - rb || db - da;
      return db - da;
    }

    function apply() {
      var visible = items.filter(matches).sort(order);
      visible.forEach(function (item) { list.appendChild(item) });
      items.forEach(function (item) { item.hidden = true });
      visible.slice(0, shown).forEach(function (item) { item.hidden = false });
      if (empty) empty.hidden = visible.length > 0;
      if (more) more.hidden = visible.length <= shown;
      if (clear) clear.hidden = mode === 'all' && chosenProducts().length === 0;
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        mode = button.getAttribute('data-review-filter');
        filters.forEach(function (b) { b.setAttribute('aria-pressed', b === button ? 'true' : 'false') });
        shown = batch;
        apply();
      });
    });

    boxes.forEach(function (box) {
      box.addEventListener('change', function () { shown = batch; apply() });
    });

    if (sorter) sorter.addEventListener('change', function () { shown = batch; apply() });
    if (more) more.addEventListener('click', function () { shown += batch; apply() });

    if (clear) clear.addEventListener('click', function () {
      mode = 'all';
      filters.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-review-filter') === 'all' ? 'true' : 'false');
      });
      boxes.forEach(function (b) { b.checked = false });
      shown = batch;
      apply();
    });

    apply();
  }
  initReviewList();
  document.addEventListener('shopify:section:load', initReviewList);

  /* --- customer reviews ----------------------------------------------------
     Three small jobs: collapse the review invitation, open a photo in the
     dialog, and drive the track's arrows and dots. The track itself is a
     scroll container, so dragging, momentum and snapping are the browser's
     and none of this is needed for the reviews to be readable. */
  function initCustomerReviews() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cr-root]'), function (root) {
      if (root.dataset.crReady) return;
      root.dataset.crReady = '1';
      crWrite(root);
      crLightbox(root);
      crCarousel(root);
    });
  }

  function crWrite(root) {
    var button = root.querySelector('[data-cr-write]');
    var panel = root.querySelector('[data-cr-write-panel]');
    if (!button || !panel) return;
    /* Written open so it reads without JS; closed here now that there is a
       button to open it again. */
    panel.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });
  }

  function crLightbox(root) {
    var dialog = root.querySelector('[data-cr-lightbox]');
    if (!dialog || !dialog.showModal) return;
    var image = dialog.querySelector('[data-cr-lightbox-img]');
    var closer = dialog.querySelector('[data-cr-lightbox-close]');
    var opener = null;

    root.addEventListener('click', function (event) {
      var shot = event.target.closest ? event.target.closest('[data-cr-shot]') : null;
      if (!shot || !root.contains(shot)) return;
      opener = shot;
      image.src = shot.getAttribute('data-cr-shot');
      image.alt = shot.getAttribute('data-cr-shot-alt') || '';
      dialog.showModal();
    });

    if (closer) closer.addEventListener('click', function () { dialog.close() });
    /* Clicking the backdrop lands on the dialog itself, never on its
       contents, which is what separates the two. */
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close() });
    /* Escape and the focus trap are the dialog element's own; this only
       puts focus back where it started. */
    dialog.addEventListener('close', function () {
      image.src = '';
      if (opener) { opener.focus(); opener = null }
    });
  }

  function crCarousel(root) {
    var track = root.querySelector('[data-cr-track]');
    var nav = root.querySelector('[data-cr-nav]');
    if (!track || !nav) return;
    var slides = track.querySelectorAll('.cr-slide');
    if (!slides.length) return;

    nav.hidden = false;
    var prev = nav.querySelector('[data-cr-prev]');
    var next = nav.querySelector('[data-cr-next]');
    var dotBox = nav.querySelector('[data-cr-dots]');
    var dots = [];

    /* One card per step rather than a full screen at a time - jumping by
       however many cards fit (3 on desktop, with only 4 reviews total) left
       just two stops and a visible snap past the middle card. Every card
       gets its own dot and its own arrow-press now, so the row reads as
       one continuous slide instead of two screens. */
    function pages() {
      return { per: 1, count: slides.length };
    }

    /* The scrollable range, not the track width, is what the pages divide
       up: the last page is a short one whenever the cards do not fill it
       exactly, and page * clientWidth would ask for a position the track
       cannot reach. */
    function span() { return track.scrollWidth - track.clientWidth }

    /* Each page now is one card (see pages() above), so its scroll target
       is that card's own offsetLeft - not a fraction of the total span.
       Dividing the span evenly only lined up with real card positions when
       a page was a full screen; at one card per page it landed between
       cards, and scroll-snap then yanked the track straight back to
       whichever card was actually nearest. Clamped to span() so the last
       card or two, which cannot scroll past the end, still gets a reachable
       target instead of one the track refuses. */
    function pageAt() {
      var max = span();
      if (max <= 1) return 0;
      var here = track.scrollLeft;
      var best = 0, bestGap = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var gap = Math.abs(Math.min(slides[i].offsetLeft, max) - here);
        if (gap < bestGap) { bestGap = gap; best = i }
      }
      return best;
    }

    function goTo(page) {
      var last = pages().count - 1;
      page = Math.max(0, Math.min(page, last));
      var target = Math.min(slides[page].offsetLeft, span());
      track.scrollTo({
        left: target,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    function buildDots() {
      if (!dotBox) return;
      var info = pages();
      if (dots.length === info.count) return;
      dotBox.innerHTML = '';
      dots = [];
      for (var i = 0; i < info.count; i++) {
        (function (page) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cr-dot';
          var from = page * info.per + 1;
          var to = Math.min(slides.length, (page + 1) * info.per);
          dot.setAttribute('aria-label', from === to ? String(from) : from + '\u2013' + to);
          dot.addEventListener('click', function () { goTo(page) });
          dotBox.appendChild(dot);
          dots.push(dot);
        })(i);
      }
    }

    function paint() {
      var width = track.clientWidth;
      var at = pageAt();
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === at ? 'true' : 'false') });
      /* A rounding slack of one pixel: a snapped track rarely lands on a
         whole number and the end arrow would otherwise stay enabled. */
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft + width >= track.scrollWidth - 1;
      markFocus();
    }

    /* The card nearest the middle of the track is held at full size and the
       ones either side sit back, so the row has somewhere for the eye to
       rest. Worked out from measured positions rather than from the page
       number, so it stays right mid-drag and at every card count. */
    function markFocus() {
      var middle = track.scrollLeft + track.clientWidth / 2;
      var best = null;
      var bestGap = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var centre = slides[i].offsetLeft + slides[i].offsetWidth / 2;
        var gap = Math.abs(centre - middle);
        if (gap < bestGap) { bestGap = gap; best = slides[i] }
      }
      for (var j = 0; j < slides.length; j++) {
        slides[j].classList.toggle('is-focus', slides[j] === best);
      }
    }

    if (prev) prev.addEventListener('click', function () { goTo(pageAt() - 1) });
    if (next) next.addEventListener('click', function () { goTo(pageAt() + 1) });

    var frame = null;
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = null; paint() });
    });

    window.addEventListener('resize', function () { buildDots(); paint() });
    buildDots();
    paint();

    /* Autoplay. One interval that decides on each tick whether it should
       move, rather than a timer being torn down and rebuilt on every hover:
       it stops while the pointer is over the section, while focus is inside
       it, while the tab is in the background, and whenever someone presses
       the pause button. It never starts at all for a visitor who has asked
       their system to reduce motion. */
    if (root.getAttribute('data-cr-autoplay') !== 'true' || reduceMotion.matches) return;
    var gap = parseInt(root.getAttribute('data-cr-interval'), 10);
    if (!gap || gap < 2000) gap = 6000;

    var hovered = false, focused = false, stopped = false;
    var pause = root.querySelector('[data-cr-pause]');

    function running() {
      return !stopped && !hovered && !focused && !document.hidden;
    }

    root.addEventListener('mouseenter', function () { hovered = true });
    root.addEventListener('mouseleave', function () { hovered = false });
    root.addEventListener('focusin', function () { focused = true });
    root.addEventListener('focusout', function () { focused = false });

    /* A toggle button, so the name stays put and aria-pressed carries the
       state - renaming it as well would have a screen reader announce the
       change twice, in two different words. */
    if (pause) pause.addEventListener('click', function () {
      stopped = !stopped;
      pause.setAttribute('aria-pressed', stopped ? 'true' : 'false');
    });

    setInterval(function () {
      if (!running()) return;
      if (!track.clientWidth) return;
      var last = pages().count - 1;
      goTo(pageAt() >= last ? 0 : pageAt() + 1);
    }, gap);
  }
  initCustomerReviews();
  document.addEventListener('shopify:section:load', initCustomerReviews);

  /* mark the current nav item for the underline */
  Array.prototype.forEach.call(document.querySelectorAll('.site-nav a'), function (a) {
    if (a.getAttribute('href') === window.location.pathname) a.setAttribute('aria-current', 'page');
  });

  document.documentElement.classList.add('js-ready');
})();
